import React from 'react'
import PropTypes from 'prop-types'
import {Link} from 'react-router-dom'
import {Form as Formsy, Input, Select, Textarea} from 'formsy-react-components'
import zxcvbn from 'zxcvbn';

import ImageUpload from './ImageUpload'
import PixieImageUpload from './PixieImageUpload'
import LocationField from './LocationField'

import Component from '../Component'

import DateInput from "./DateInput";
import CheckboxInput from "./CheckboxInput";
import NumberInput from "./NumberInput";
import RadioInput from "./RadioInput";
import MaskedInput from "./MaskedInput";
import SwitchInput from "./SwitchInput";
import SettingInput from "./SettingInput";
import SearchInput from "./SearchInput";
import RatingInput from "./RatingInput";
import ExperienceInput from "./ExperienceInput";
import FileUpload from "./FileUpload";
import PasswordField from "./PasswordField";
import ExperienceRadioGroup from "./ExperienceRadioGroup";
import MultiSelectInput from "./MultiSelectInput";
import FileButtonInput from "./FileButtonInput";
import PreferenceRatingInput from "./PreferenceRatingInput";
import CheckboxGroupInput from "./CheckboxGroupInput";
import MultiInputGroup from "./MultiInputGroup";
import CreatableMultiSelect from "../CreatableMultiSelect";
import TextEditorInput from "./TextEditorInput";
import {ContentState, convertFromHTML, EditorState} from "draft-js";
import {extractLinks} from "@draft-js-plugins/linkify";
import {convertToHTML} from "draft-convert";
import punycode from "punycode";
import InputWrapper from "./InputWrapper";
import LexicalTextEditor from "./LexicalTextEditor";
import MultiImageUpload from "./MultiImageUpload";
import MultiDocUpload from "./MultiDocUpload";

const exporterConfig = {
    styleToHTML: (style) => {
        if (style === "center") {
            return <span style={{textAlign: "center"}}/>
        }

        if (style === "left") {
            return <span style={{textAlign: "left"}}/>
        }

        if (style === "right") {
            return <span style={{textAlign: "right"}}/>
        }
    },
    blockToHTML: (block) => {
        if (TB.first(extractLinks(block.text))?.text === block.text) {
            return <a href={block.text} target="_blank"/>
        }
        if (block.type === 'PARAGRAPH') {
            return <p/>;
        }
    },
    entityToHTML: (entity, originalText) => {
        if (entity.type === 'LINK') {
            return <a href={entity.data.url} target="_blank">{originalText}</a>;
        }
        return originalText;
    }
}

export default class Form extends Component {
    static propTypes = {
        model: PropTypes.object,

        fields: PropTypes.oneOfType([
            PropTypes.object,
            PropTypes.arrayOf(PropTypes.object),
        ]),

        links: PropTypes.array,


        title: PropTypes.oneOfType([
            PropTypes.bool,
            PropTypes.element,
            PropTypes.string,
            PropTypes.arrayOf(PropTypes.string),
        ]),
        subtitle: PropTypes.string,

        submitButton: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.bool,
            PropTypes.object,
        ]),

        cancelButton: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.bool,
            PropTypes.object,
        ]),

        background: PropTypes.any,
        showUnloadWarning: PropTypes.bool,
        showRequired: PropTypes.bool,

        post: PropTypes.string,

        mapping: PropTypes.func,
        onChange: PropTypes.func,
        onSubmit: PropTypes.func,

        onSuccess: PropTypes.func,
        transformRequest: PropTypes.func,
        onError: PropTypes.func,
        onBeforeError: PropTypes.func,
        onUnhandledError: PropTypes.func,
    };

    static defaultProps = {
        model: {},
        fields: {},
        links: [],

        showUnloadWarning: true,
        showRequired: false,

        submitButton: {
            title: 'Submit',
            show: true,
            type: 'primary',
        },

        cancelButton: false,

        background: 'white',

        onChange: () => true,
        onSubmit: () => true,
    };

    constructor(props) {
        super(props);

        this.request = null;

        this.formRef = React.createRef();


        this.state = {
            isDisabled: false,
            model: {...(this.props.model || {})},
        };
    }

    componentDidMount() {
        // if (this.props.showUnloadWarning) {
        //     window.onbeforeunload = this.unloadPage.bind(this);
        // }

        super.componentDidMount();
    }

    componentWillUnmount() {
        // window.onbeforeunload = null;
        super.componentWillUnmount();
    }

    static getDerivedStateFromProps(props, state) {
        // console.log('Form @ getDerivedStateFromProps')
        // console.log('props', props, 'state', state);

        if (props.model) {
            state.model = {...props.model};
        }

        return state;
    }


    /*
    |--------------------------------------------------------------------------
    | Handling Requests
    |--------------------------------------------------------------------------
    */

    toggleDisabled(isDisabled) {
        this.setState({isDisabled});
    }

    shouldSendRequest() {
        return TB.isString(this.props.post);
    }

    async sendRequest(data) {

        // TB.log().object(
        //     'Form @ sendRequest', {...data}
        // );

        if (TB.isFunction(this.props.transformRequest)) {
            data = this.handler('transformRequest', {...data})
        }

        this.request = TB.request(
            TB.api_endpoint(this.props.post), {...data}
        );

        if (this.hasFileField()) {
            this.request = this.request.headers({
                'Content-Type': 'multipart/form-data',
            });
        }

        this.toggleDisabled(true);

        let response = await this.request.post().catch(
            console.warn
        );

        this.toggleDisabled(false);

        if (!response) {
            this.handler(
                'onBeforeError', this.request.error
            );

            this.request.didHandleError = await this.request.handleError();
            if (this.request.didHandleError
                && this.request.shouldRerun) {
                return this.sendRequest(data);
            }

            return;
        }

        return response.success;
    }


    /*
    |--------------------------------------------------------------------------
    | Handling Events
    |--------------------------------------------------------------------------
    */

    findFieldByProp(prop) {
        if (this.props.fields[prop]) {
            return this.props.fields[prop];
        }

        for (let key in this.props.fields) {
            if (TB.isObject(this.props.fields[key])
                && TB.isObject(this.props.fields[key].fields)
                && this.props.fields[key].fields[prop]) {
                return this.props.fields[key].fields[prop];
            }
        }
    }

    mutateModel(model) {
        // console.log('Form @ mutateModel -> model');
        // console.log(model);
        // console.log(this.props.fields);
        let updatedModel = {...model};

        for (let prop in updatedModel) {
            let field = this.findFieldByProp(prop);
            if (!field) {
                // console.log(`Form @ mutateModel, missing field: ${prop}`);
                continue;
            }

            if ((field.type === 'radio'
                    || field.type === 'select'
                    || field.type === 'boolean')
                && !isNaN(updatedModel[prop])) {
                updatedModel[prop] = parseInt(updatedModel[prop]);
            }

            if (field.type === 'date') {
                // updatedModel[prop] = dateFormat(updatedModel[prop], 'mmm dS yyyy');
            }
        }

        // console.log('Form @ mutateModel -> updatedModel');
        // console.log(updatedModel);

        return updatedModel;
    }

    mapping(model) {
        let updatedModel = this.mutateModel(model);
        let newMapping = this.handler('mapping', updatedModel);

        if (newMapping === false) {
            return {...updatedModel};
        }

        return newMapping;
    }

    inputFields() {
        if (!this.formRef.current || !this.formRef.current.formsyForm) {
            return [];
        }

        return this.formRef.current.formsyForm.inputs;
    }

    unloadPage() {
        if (!this.props.showUnloadWarning) {
            return;
        }

        if (this.state.isChanged) {
            return "You have unsaved changes on this page. Are you sure you want to discard your changes and leave this page?";
        }
    }

    hasChanged() {
        return this.state.isChanged
    }

    onChange(model, isChanged) {
        let updatedModel = this.mutateModel(model);

        if (isChanged) {
            this.setState({model: updatedModel});
            this.handler('onChange', updatedModel, isChanged);
        }
    }

    isFormSubmitted() {
        return this.formRef.current?.formsyForm?.state.formSubmitted;
    }

    forceValidate() {
        this.formRef.current?.formsyForm.setFormPristine()

        if (!this.state.isValid) {
            let invalidInputs = TB.filter(this.inputFields(), input => {
                return !input.isValid();
            });
            console.log('forceValidate', invalidInputs)
            return TB.first(invalidInputs);
        }

        return;
    }

    updateInputsWithValue(model, validate) {

        for (let [key, value] of Object.entries(model)) {
            let input = TB.find(this.inputFields(), ['props.name', key])
            if (input && input.getValue() !== value) {
                input.resetValue();
                input.setValue(value, validate);
            }
        }
    }

    updateInputsWithError(model) {
        if (!this.formRef.current) return;

        this.formRef.current.formsyForm.updateInputsWithError(
            model
        );

        return this.validateForm();
    }

    validateForm() {
        return this.formRef.current.formsyForm.validateForm()
    }

    forceReset(model) {
        this.setState({model, isChanged: false})
        return this.formRef.current.formsyForm.reset(model)
    }

    async onSubmit(model, reset, invalidate) {
        if (!this.state.isValid) {
            let invalidInputs = TB.filter(this.inputFields(), input => {
                return !input.isValid();
            });
            // console.log(invalidInputs);
            return;
        }
        if (this.props.customValidate && !this.props.customValidate()) {
            return;
        }

        let modelChanges = {...model};
        let fileInputs = TB.filter(this.inputFields(), input => {
            return this.fileFieldNames().indexOf(input.props.name) !== -1;
        });
        for (let input of fileInputs) {
            if (input.isPristine()) {
                delete modelChanges[input.props.name];
            }
        }

        this.handler('onSubmit', modelChanges);

        if (!this.shouldSendRequest()) {
            return;
        }

        let responseData = await this.sendRequest(modelChanges);
        if (responseData) {
            this.promisedState({isChanged: false});
            return this.handler(
                'onSuccess', responseData
            );
        }

        console.log('onSubmit', this.request);
        if (this.request.didHandleError) {
            return this.handler(
                'onError', this.request.error
            );
        }

        // Handle invalid input response
        if (this.hasInputResponseError()) {
            this.handler(
                'onInputResponseError', this.request.error
            );
            return this.handleInputResponseError();
        }

        this.handler(
            'onUnhandledError', this.request.error
        );
    }

    hasInputResponseError() {
        return TB.has(this.request || {}, 'response.data.error') &&
            this.request.response.data.error.data &&
            this.request.statusCode() === 422;
    }

    handleInputResponseError(request) {
        if (!request) {
            request = this.request;
        }
        let formErrors = {...request.response.data.error.data};
        for (let key in formErrors) {
            let formInputs = TB.filter(this.inputFields(), input => {
                return input.props.name === key;
            });
            if (!formInputs.length) {
                continue;
            }

            let feedbackKey = formInputs[0].props.name.toLowerCase() || formInputs[0].props.label.toLowerCase();
            let messageKey = key;

            for (let i in formErrors[key]) {
                formErrors[key][i] = formErrors[key][i].replace(messageKey, TB.replace(feedbackKey, '_', ' '));
            }
        }


        if (Object.keys(formErrors).length) {
            this.formRef?.current?.formsyForm?.updateInputsWithError(
                formErrors, true
            );

            return TB.find(this.inputFields(), ['props.name', Object.keys(formErrors)[0]])
        } else return false
    }

    handler(name, ...params) {
        if (!TB.isFunction(this.props[name])) {
            return false;
        }

        return this.props[name](...params);
    }

    /*
    |--------------------------------------------------------------------------
    | Rendering Components
    |--------------------------------------------------------------------------
    */

    renderTitle() {
        let {title, subtitle} = this.props;

        if (!title && !subtitle) return null;
        let titleLines = [title];
        if (!Array.isArray(title)) {
            titleLines = [titleLines];
        }

        if (React.isValidElement(title)) {
            return title;
        }

        return (
            <div className="form-title-section" style={{margin: '0 5%'}}>
                {TB.isString(subtitle) && (
                    <h5 className='form-subtitle px-4' style={{
                        lineHeight: 1.5,
                        marginTop: 5,
                        fontSize: 16
                    }}>
                        {subtitle}
                    </h5>
                )}
                {TB.isDefined(title) && (
                    <h3 className="form-title">
                        {titleLines.map((line, index) => (
                            <span style={{marginTop: 3}} key={`titleLine${index}`}>
                                {line} {index < (titleLines.length - 1) && (<br/>)}
                            </span>
                        ))}
                    </h3>
                )}
            </div>
        );
    }

    render() {
        let {isDisabled} = this.state;
        if (this.props.isDisabled) {
            isDisabled = true;
        }

        let {
            children,
            background = 'transparent',
            className = '',
            submitButton,
            cancelButton,
            links,
            showRequired,
            showUnloadWarning,
            validateBeforeSubmit
        } = this.props;

        if (TB.isString(submitButton)) {
            submitButton = {
                title: submitButton,
                show: true,
                type: 'primary',
            };
        } else if (TB.isBoolean(submitButton)
            || submitButton === undefined
            || submitButton === null) {
            submitButton = {
                title: 'Submit',
                show: submitButton !== false,
                type: 'primary',
            };
        }

        if (TB.isString(cancelButton)) {
            cancelButton = {
                title: cancelButton,
                show: true,
                type: 'outline-primary',
            };
        } else if (TB.isBoolean(cancelButton)
            || cancelButton === undefined
            || cancelButton === null) {
            cancelButton = {
                title: 'Cancel',
                show: cancelButton !== false,
                type: 'outline-primary',
            };
        }


        className += ' wripple-form ';

        if (this.props.minimal) {
            className = ''
        }
        className += (isDisabled ? ' form-disabled ' : '');
        className += (!showRequired ? 'hide-required' : '');

        return (
            <div className={className}>
                {/*<Prompt
                    when={showUnloadWarning && this.state.isChanged}
                    message={location => this.unloadPage()}
                />*/}
                <div className={this.props.minimal ? '' : 'form-container'} style={{background}}>

                    {this.renderTitle()}


                    <Formsy
                        ref={this.formRef}
                        className="many-fields"
                        layout="vertical"
                        encType="multipart/form-data"
                        onValid={() => {
                            this.setState({isValid: true});
                        }}
                        onInvalid={() => {
                            this.setState({isValid: false});
                        }}
                        validateBeforeSubmit={validateBeforeSubmit}
                        onChange={this.onChange.bind(this)}
                        onSubmit={this.onSubmit.bind(this)}
                        mapping={this.mapping.bind(this)}
                        {...(this.props.formProps || {})}
                    >

                        {this.fieldSections().map(this.renderFieldSection.bind(this))}

                        {children}

                        {((links && links.length > 0) || (TB.isObject(submitButton) && submitButton.show)) && (
                            <div className="form-footer">

                                {TB.isObject(submitButton) && submitButton.show && (
                                    <div className="form-buttons">
                                        {TB.isObject(cancelButton) && cancelButton.show && (
                                            <button type="button"
                                                    disabled={isDisabled}
                                                    onClick={() => this.handler('onCancel')}
                                                    className={`mr-3 btn-submit btn btn-${cancelButton.type ? cancelButton.type : 'outline-primary'}`}>

                                                {cancelButton.title}
                                            </button>
                                        )}

                                        <button type="submit"
                                                formNoValidate
                                                disabled={isDisabled}
                                                className={`btn-submit btn btn-${submitButton.type ? submitButton.type : 'primary'}`}>

                                            {submitButton.title}
                                        </button>
                                    </div>
                                )}


                                {links && links.length > 0 && (
                                    <div className="form-links">
                                        {links.map((link, linkKey) => (
                                            <div key={'link' + linkKey}
                                                 style={{flexBasis: ((link.columns || 12) / 12) * 100 + "%"}}
                                                 className="form-links text-center">

                                                {link.onClick ? (
                                                    <a href="#" onClick={link.onClick} className="text-link">
                                                        {link.title}
                                                    </a>
                                                ) : (
                                                    <Link to={link.path || "#"} className="text-link">
                                                        {link.title || 'More..'}
                                                    </Link>
                                                )}

                                            </div>
                                        ))}

                                    </div>
                                )}
                            </div>

                        )}

                    </Formsy>
                </div>
            </div>
        )
    }

    /*
    |--------------------------------------------------------------------------
    | Manipulating Form Fields/Sections
    |--------------------------------------------------------------------------
    */

    fieldSections() {
        const {fields} = this.props;

        let fieldSections = [{
            style: {background: 'transparent'},
            fields,
        }];

        if (Array.isArray(fields)) {
            fieldSections = fields;
        }

        return fieldSections;
    }

    hasFileField() {
        return this.fileFieldNames().length > 0;
    }

    fileFieldNames() {
        let sections = this.fieldSections();

        let typesLookup = {
            image: true,
            file: true,
            pixie: true
        };

        let fieldNames = [];
        for (let section of sections) {
            for (let key in section.fields) {
                let field = section.fields[key];
                if (typesLookup[field.type]) {
                    fieldNames.push(key);
                }
            }
        }

        return fieldNames;
    }

    /*
    |--------------------------------------------------------------------------
    | Rendering Form Fields/Sections
    |--------------------------------------------------------------------------
    */


    renderFieldSection(fieldSection, key) {
        let {style = {}, fields, className = 'field-section'} = fieldSection;


        return (
            <div key={'section' + key}
                 className={className}
                 style={style}>

                {Object.keys(fields).length > 0 && Object.keys(fields).map(
                    (fieldName, i) => {
                        let sectionsFields = fields[fieldName];

                        if (sectionsFields['fields']) {
                            let section = {
                                ...sectionsFields,
                                style: sectionsFields['style'] || {},
                                fields: sectionsFields['fields']
                            };

                            return (
                                <div className={"field-section-group " + (fieldSection['groupClass'] || '')}
                                     style={fieldSection['groupStyle'] || {}} key={`field-section-group-${i}`}>
                                    {this.renderFieldSection(section)}
                                </div>
                            )
                        }

                        return this.renderField(fieldName, fields[fieldName])
                    }
                )}
            </div>
        )
    }

    renderField(fieldName, params) {
        let key = 'input' + fieldName;

        let options = {...params};

        options.name = options.name ? options.name : fieldName;

        if (options.label && TB.isString(options.label) && options.label.includes('.') && TB.tryTrans(options.label)) {
            options.label = TB.tryTrans(options.label);
        }
        options.label = options.label || options.label === false
            ? options.label : TB.startCase(TB.camelCase(fieldName));

        options.required = options.hasOwnProperty('required') ? options.required : true;

        options.type = options.type ? options.type : 'text';

        options.disabled = options.disabled ? options.disabled : this.state.isDisabled;

        if (this.props.isDisabled) {
            options.disabled = true;
        }
        if (this.state.model
            && TB.has(this.state.model, fieldName)) {
            options.value = TB.get(this.state.model, fieldName);
        }

        let component = this.constructor.getFormComponent(fieldName, options), className;

        switch (options.type) {
            case 'image':
            case 'pixie':
                className = 'field text-center';
                break;

            case 'multi-image':
            case 'multi-doc':
                className = '';
                break;
            case 'checkbox':
                className = (options.className || '') + (options.checkboxClass || '') + ' field mt-1';
                break;
            case 'select':
                className = 'field select-field ' + (options.className || '');
                break;
            case 'hidden-date':
                className = options.className || 'hide-input';
                break;
            case 'button':
            case 'submit':
                className = ' ';
                break;

            case 'antd-number':
            case 'antd-input':
            case 'date':
            case 'currency':
            case 'masked':
            case 'textarea':
            case 'text':
            case 'number':
            case 'email':
            case 'tel':
            case 'url':
            case 'hidden':
            case 'password_confirmation':
            case 'password':
                className = options.className || '';
                break;

        }

        if (!component) {
            return <div key={key}/>
        }

        return (
            (<div key={key}
                 style={{flexBasis: ((options.columns || 12) / 12) * 100 + "%", ...(options.style || {})}}
                 className={className ? className : 'field'}>
                {component}
            </div>)
        );
    }

    static getFormComponent(fieldName, params) {
        let key = 'input' + fieldName;

        let options = {...params};

        if (React.isValidElement(params)) {
            return <div key={key}
                        className={'field-element'}>{params}</div>;
        }

        if (options.component
            && (React.isValidElement(options.component) || TB.isReactComponent(options.component))) {
            const InputComponent = options.component;
            return (
                (<div key={key}
                     style={{flexBasis: ((options.columns || 12) / 12) * 100 + "%", ...(options.style || {})}}
                     className={options.className ? options.className : 'field-element'}>
                    {TB.isReactComponent(InputComponent)
                        ? <InputComponent {...options}/>
                        : InputComponent}
                </div>)
            );
        }

        if (options.type === 'select'
            && !TB.isArray(options.options)) {
            options.options = this.toSelectOptions(
                options.options, options.placeholder
            );
        } else if (options.type === 'radio'
            && !TB.isArray(options.options)) {
            options.options = this.toRadioOptions(
                options.options
            );
        } else if (options.type === 'boolean') {
            options.options = [
                {
                    label: 'Yes',
                    value: 1,
                },
                {
                    label: 'No',
                    value: 0,
                },
            ];
        }

        if (options.value === null) {
            options.value = undefined;
        }

        let validation = this.validationFor(
            options
        );

        if (options.validation) {
            if (typeof options.validation !== 'string') {
                validation.rules = options.validation.rules;
            }
            validation.errors = {
                ...validation.errors,
                ...options.validation.errors,
            }
        }

        options.validation = validation;

        let component;

        switch (options.type) {
            case 'editor':

                const toHTML = (content) => convertToHTML(exporterConfig)(content);

                const checkLength = (content) => {

                    let decodeUnicode = (str) => {
                        return punycode.ucs2.decode(str);
                    }; // func to handle unicode characters


                    let plainText = content.getPlainText('');
                    let regex = /(?:\r\n|\r|\n)/g; // new line, carriage return, line feed

                    let cleanString = plainText.replace(regex, '').trim();
                    return decodeUnicode(cleanString).length
                }
                let validations = {};
                if (options.maxLength || !TB.isNaN(parseInt(options.minLength))) {
                    if (!TB.isNaN(parseInt(options.minLength))) {
                        let minLength = options.minLength;

                        options.validation.rules = {
                                ...options.validation.rules,
                                minCharLength(model, value)  {
                                    if (!value) {
                                        return true
                                    }

                                    const blocksFromHTML = convertFromHTML(value);

                                    let editorState = EditorState.createWithContent(
                                        ContentState.createFromBlockArray(
                                            blocksFromHTML.contentBlocks,
                                            blocksFromHTML.entityMap,
                                        )
                                    )

                                    let totalChars = checkLength(editorState.getCurrentContent());

                                    return totalChars > minLength
                            }
                        }
                        if(options.validation.errors && !options.validation.errors.minCharLength){
                            let inputName = (options.label && TB.isString(options.label))
                                ? options.label.toLowerCase()
                                : options.name.replace('_', ' ');
                            options.validation.errors.minCharLength = TB.trans('validation.min.string', {
                                'attribute': inputName,
                                'min': minLength
                            })
                        }
                    }
                }

                // Convert maxLength to a rich-text-aware validation that checks
                // plain text length instead of HTML string length
                // if (options.validation?.rules?.maxLength) {
                //     let richTextMax = options.validation.rules.maxLength;
                //     delete options.validation.rules.maxLength;

                //     options.validation.rules.richTextMaxLength = (values, value) => {
                //         if (!value) return true;
                //         const tmp = document.createElement('div');
                //         tmp.innerHTML = value;
                //         const textLength = (tmp.textContent || tmp.innerText || '').length;
                //         return textLength <= richTextMax;
                //     };

                //     let inputName = (options.label && TB.isString(options.label))
                //         ? options.label.toLowerCase()
                //         : options.name.replace('_', ' ');
                //     options.validation.errors.richTextMaxLength =
                //         options.validation.errors.maxLength ||
                //         TB.trans('validation.max.string', {
                //             'attribute': inputName,
                //             'max': richTextMax
                //         });
                //     delete options.validation.errors.maxLength;
                // }

                component = <TextEditorInput validations={options.validation?.rules}
                                             validationErrors={options.validation?.errors} {...options}/>;
                break;

            case 'switch':
                component = <SwitchInput {...options}/>;
                break;
            case 'ant-switch':
                component = <SwitchInput antSwitch {...options}/>;
                break;
            case 'lexical-editor':
                // Convert maxLength to a rich-text-aware validation that checks
                // plain text length instead of HTML string length
                // if (options.validation?.rules?.maxLength) {
                //     let richTextMax = options.validation.rules.maxLength;
                //     delete options.validation.rules.maxLength;

                //     options.validation.rules.richTextMaxLength = (values, value) => {
                //         if (!value) return true;
                //         const tmp = document.createElement('div');
                //         tmp.innerHTML = value;
                //         const textLength = (tmp.textContent || tmp.innerText || '').length;
                //         return textLength <= richTextMax;
                //     };

                //     let inputName = (options.label && TB.isString(options.label))
                //         ? options.label.toLowerCase()
                //         : options.name.replace('_', ' ');
                //     options.validation.errors.richTextMaxLength =
                //         options.validation.errors.maxLength ||
                //         TB.trans('validation.max.string', {
                //             'attribute': inputName,
                //             'max': richTextMax
                //         });
                //     delete options.validation.errors.maxLength;
                // }

                component = <LexicalTextEditor validations={options.validation?.rules}
                                               validationErrors={options.validation?.errors} {...options}/>;
                break;
            case 'preference-rating':
                component = <PreferenceRatingInput {...options}/>;
                break;
            case 'setting':
                // options.name = options.setting.settings_prop;
                options.label = options.setting.name;
                options.description = options.setting.description;

                component = <SettingInput {...options}/>;
                break;
            case 'search':
                component = <SearchInput {...options}/>;
                break;
            case 'checkbox-group':
                component = <CheckboxGroupInput {...options}/>;
                break;
            case 'multi-input-group':
                component = <MultiInputGroup {...options}/>;
                break;
            case 'creatable-multi-select':
                component = <CreatableMultiSelect {...options}/>;
                break;
            case 'multiselect':
                component = <MultiSelectInput {...options}/>;
                break;
            case 'new_password':
                component = this.passwordField(options);
                break;
            case 'experience':
                component = this.experienceField(options);
                break;
            case 'min_experience':
                component = this.minExperienceField(options);
                break;
            case 'rating':
                component = this.ratingField(options);
                break;
            case 'location':
                component = this.locationField(options);
                break;
            case 'image':
                component = this.imageField(options);
                break;
            case 'pixie':
                component = this.pixieImageField(options);
                break;
            case 'multi-image':
                component = this.multiImageField(options);
                break;
            case 'multi-doc':
                component = this.multiDocField(options);
                break;
            case 'file':
                component = this.fileField(options);
                break;
            case 'file_button':
                component = this.fileBtnField(options);
                break;
            case 'checkbox':
                component = this.checkboxField(options);
                break;
            case 'radio':
            case 'boolean':
                component = this.radioField(options);
                break;
            case 'select':
                component = this.selectField(options);
                break;
            case 'button':
            case 'submit':
                component = this.buttonField(options);
                break;
            case 'date':
                component = this.dateField(options);
                break;
            case 'currency':
                component = this.currencyField(options);
                break;
            case 'masked':
                component = this.maskedField(options);
                break;
            case 'textarea':
                component = this.textAreaField(options);
                break;
            case 'hidden-date':
                options.type = 'date';
                component = this.inputField(options);
                break;
            case 'number':
            case 'text':
            case 'email':
            case 'tel':
            case 'url':
            case 'hidden':
            case 'password_confirmation':
            case 'password':
                component = this.inputField(options);
                break;


            case 'antd-number':
            case 'antd-input':
                component = (
                    <InputWrapper
                        {...options}
                        validations={options?.validation?.rules}
                        validationErrors={options?.validation?.errors}/>
                )
                break;
            default:
                throw new Error("Unknown field type: " + options.type);
        }

        return component;
    }

    static validationFor(options) {
        let inputName = (options.label && TB.isString(options.label))
            ? options.label.toLowerCase()
            : options.name.replace('_', ' ');

        if (options.label === false) {
            inputName = '';
        }
        if (inputName === '' && options.reviewLabel) {
            inputName = options.reviewLabel
        }

        let rules = {}, errors = {
            isDefaultRequiredValue: TB.trans('validation.required', {
                'attribute': inputName,
            }),
            ...(options.validationErrors || {})
        };


        switch (options.type) {
            case 'masked':
                rules.minLength = String(options.mask).length;

                errors.minLength = TB.trans('validation.regex', {
                    'attribute': inputName,
                });
                break;
            case 'email':
                rules.isEmail = true;
                errors.isEmail = TB.trans('validation.email', {
                    'attribute': inputName,
                });
                break;

            case 'number':
                rules.isInt = true;
                if (!errors.isInt) {
                    errors.isInt = TB.trans('validation.integer', {
                        'attribute': inputName,
                    });
                }
                if (options.minLength || options.min) {
                    rules.minLength = options.minLength || options.min;
                    errors.minLength = `Must be greater than ${options.minLength || options.min}`;
                }

                let min = options.minLength || options.min;
                if (!min || min === 0) {
                    rules.matchRegexp = /^(0*[1-9][0-9]*(\.[0-9]+)?|0+\.[0-9]*[1-9][0-9]*)$/
                    errors.matchRegexp = `Must be greater than 0`;
                }

                if (options.maxLength || options.max) {
                    rules.maxLength = options.maxLength || options.max;
                    errors.maxLength = `Must be less than ${options.maxLength || options.max}`;
                }
                break;

            case 'url':
                rules.matchRegexp = /^(http|https):\/\//;
                rules.isUrl = true;

                errors.matchRegexp = 'Must start with http(s)://';
                errors.isUrl = TB.trans('validation.active_url', {
                    'attribute': inputName,
                });
                break;

            case 'password':
                rules.minLength = 8;
                rules.maxLength = 16;
                errors.minLength = "Must be between 8 and 16 characters";
                errors.maxLength = "Must be between 8 and 16 characters";
                break;

            case 'password_confirmation':
                rules.minLength = 8;
                rules.maxLength = 16;
                rules.equalsField = "password";
                errors.minLength = "Must be between 8 and 16 characters";
                errors.maxLength = "Must be between 8 and 16 characters";
                errors.equalsField = "The password confirmation doesn't match";
                break;
        }

        if (options.validation && TB.keys(options.validation).length) {
            rules = {
                ...rules,
                ...options.validation
            };
        }

        return {
            rules,
            errors
        };
    }

    /**
     * [Note]
     *
     * @returns {Array}
     * @param items
     */
    static toRadioOptions(items) {
        let options = TB.map(items, (name, id) => {
            let value = id;
            if (!isNaN(value)) {
                value = parseInt(value);
            }

            return {
                label: name,
                value: value,
            };
        });

        return options;
    }

    /**
     * [Note]
     *
     * @returns {Array}
     * @param items
     * @param placeholder
     */
    static toSelectOptions(items, placeholder = '-- Select --') {

        return [{
            label: placeholder,
            value: '',
            disabled: true
        }].concat(
            this.toRadioOptions(items)
        );
    }


    /*
    |--------------------------------------------------------------------------
    | Rendering Form Fields of Certain Type
    |--------------------------------------------------------------------------
    */

    static fileField(options) {
        let {
            validation,
            accept,
            ...props
        } = options;

        return (
            <FileUpload
                {...props}
                accept={accept}
                validations={validation.rules}
                validationErrors={validation.errors}/>
        );
    }

    static fileBtnField(options) {
        let {
            validation,
            accept,
            ...props
        } = options;

        return (
            <FileButtonInput
                {...props}
                accept={accept}
                validations={validation.rules}
                validationErrors={validation.errors}/>
        );
    }

    static maskedField(options) {
        let {
            validation,
            ...props
        } = options;
        return (
            <MaskedInput
                {...props}
                validations={validation.rules}
                validationErrors={validation.errors}
                validateSubmitted={false}
            />
        );
    }

    static minExperienceField(options) {
        let {
            validation,
            ...props
        } = options;
        return (
            <ExperienceRadioGroup
                {...props}
                validations={validation.rules}
                validationErrors={validation.errors}
            />
        );
    }

    static experienceField(options) {
        let {
            validation,
            ...props
        } = options;
        return (
            <ExperienceInput
                {...props}
                validations={validation.rules}
                validationErrors={validation.errors}
            />
        );
    }

    static ratingField(options) {
        let {
            validation,
            ...props
        } = options;
        return (
            <RatingInput
                {...props}
                validations={validation.rules}
                validationErrors={validation.errors}
            />
        );
    }

    static passwordField(options) {
        let {
            validation,
            ...props
        } = options;
        return (
            <PasswordField
                {...props}
                validations={{
                    validatePasswordStrong: (values, value) => {
                        if (value && value.length <= 8) return "Password is too short";
                        if (value && zxcvbn(value).score < 2) return "Password is too weak";
                        if (value && value.length > 16) return "Password must be between 8 and 16 characters";

                        return true
                    }
                }}
                validationErrors={validation.errors}
                validateBeforeSubmit={true}
            />
        );
    }

    static currencyField(options) {
        return (
            <NumberInput
                {...options}
            />
        );
    }


    static dateField(options) {
        let {
            validation,
            minDateField
        } = options;

        // if (options.minDateField) {
        //     minDateField = TB.find(this.inputFields(), ['props.name', options.minDateField])
        // }

        return (
            <DateInput
                {...options}
                minDateField={minDateField}
                validations={validation.rules}
                validationErrors={validation.errors}
            />
        );
    }

    static inputField(options) {
        let {
            type,
            label,
            name,
            labelClassName,
            elementWrapperClassName,
            value,
            placeholder,
            autoComplete,
            disabled,
            isReadOnly,
            required,
            validation,
            onChange,
            changeCallback,
            addonBefore,
            className,
            min,
            max,
            minLength,
            maxLength,
            addonAfter,
            layout = 'vertical'
        } = options;

        let inputType = type;
        if (inputType === 'password' && !autoComplete) {
            autoComplete = "current-password"
        }
        if (inputType === 'password_confirmation') {
            inputType = 'password';
        }
        if (inputType === 'password' && !placeholder) {
            placeholder = '********';
        }
        if (inputType === 'number') {

        }
        if (inputType === 'currency') {
            inputType = 'number';
            addonBefore = '$';
            if (!TB.isDefined(min) && !TB.isDefined(minLength)) {
                min = 1;
            }
        }

        return (
            <Input
                type={inputType}
                label={label}
                min={min}
                max={max}
                labelClassName={labelClassName}
                elementWrapperClassName={elementWrapperClassName || className}
                minLength={minLength}
                maxLength={maxLength}
                name={name}
                className={className}
                value={value}
                tabIndex={isReadOnly ? -1 : undefined}
                changeCallback={changeCallback}
                onChange={onChange}
                layout={layout}
                placeholder={placeholder}
                autoComplete={autoComplete}
                disabled={disabled}
                required={required}
                addonBefore={addonBefore}
                addonAfter={addonAfter}
                validations={validation.rules}
                validationErrors={validation.errors}
            />
        );
    }

    static textAreaField(options) {
        let {
            label,
            name,
            value,
            placeholder,
            autoComplete,
            disabled,
            required,
            validation,
            onChange,
            rows,
            className,
            minLength,
            maxLength,
            labelClassName,
            layout = 'vertical'
        } = options;

        if (label === false) {
            labelClassName = 'hidden';
        }

        return (
            <Textarea
                label={label}
                labelClassName={labelClassName}
                name={name}
                className={className}
                value={value}
                onChange={onChange}
                layout={layout}
                minLength={minLength}
                maxLength={maxLength}
                placeholder={placeholder}
                autoComplete={autoComplete}
                disabled={disabled}
                required={required}
                rows={rows}
                validations={validation.rules}
                validationErrors={validation.errors}/>
        );
    }

    static checkboxField(options) {
        let {
            label,
            name,
            value,
            disabled,
            required,
            isReadOnly,
            validation,
            checkboxClass,
        } = options;

        return (
            <CheckboxInput
                name={name || ''}
                valueLabel={label || ''}
                value={value}
                disabled={disabled}
                required={required}
                isReadOnly={isReadOnly}
                validations={validation.rules}
                validationErrors={validation.errors}
                checkboxClass={checkboxClass}/>
        );
    }

    static radioField(settings) {
        let {
            label,
            name,
            value,
            disabled,
            required,
            validation,
            options,
            inline,
            className
        } = settings;

        if (TB.isString(value) && !isNaN(value)) {
            value = parseInt(value);
        }
        if (TB.isBoolean(value)) {
            value = value ? 1 : 0;
        }

        return (
            <RadioInput
                name={name}
                label={label}
                value={value}
                className={className}
                type={inline ? 'inline' : null}
                options={options}
                disabled={disabled}
                required={required}
                validations={validation.rules}
                validationErrors={validation.errors}/>
        );
    }

    static selectField(settings) {
        let {
            label,
            name,
            labelClassName,
            elementWrapperClassName,
            value,
            disabled,
            required,
            validation,
            options,
            layout
        } = settings;
        return (
            <Select
                name={name}
                label={label}
                value={value || ''}
                className={!value ? 'not-selected' : 'wripple-select-input'}
                layout={layout}
                options={options}
                disabled={disabled}
                required={required}
                labelClassName={labelClassName}
                elementWrapperClassName={elementWrapperClassName}
                validateBeforeSubmit={false}
                validations={validation.rules}
                validationErrors={validation.errors}/>
        );
    }

    static buttonField(options) {
        let className = options.primary ? "btn btn-primary" : "btn";

        return (
            <button type={options.type}
                    formNoValidate
                    disabled={options.disabled}
                    className={className}>

                {options.label}

            </button>
        );
    }

    static locationField(options) {
        let {
            label,
            name,
            value,
            disabled,
            required,
            validation,
            includeAddress,
            additionalProps,
            showClearButton,
            ...addProps
        } = options;

        return (
            <LocationField
                name={name}
                includeAddress={includeAddress}
                label={label}
                value={value}
                disabled={disabled}
                required={required}
                validations={validation.rules}
                validationErrors={validation.errors}
                additionalProps={additionalProps}
                showClearButton={showClearButton}
                onError={error => {
                    // return this.updateInputsWithError({
                    //     location: 'Unable to find location',
                    // });
                }}
                {...(addProps || {})}
            />
        );
    }

    static imageField(options) {
        let {
            label,
            labelHint,
            name,
            value,

            width,
            height,
            ratio,
            circular,
            dropContainer,
            disabled,
            required,
            validation,
            freeCrop,
            minWidth,
            minHeight,
            ...extraProps
        } = options;

        // ImageUpload props
        // source = value (nullable string - url of image)
        // width @= int (optional, default=150)
        // height @= int pixels (optional, default=auto)
        // ratio @= float (optional, default=null)
        // circular @= bool (optional, default=false)
        // ImageUpload methods
        // + onError(error => )
        // handle bad mime type
        // handle size too large

        return (
            <ImageUpload
                label={label}
                name={name}
                source={value}
                value={value}
                disabled={disabled}
                width={width}
                height={height}
                dropContainer={dropContainer}
                ratio={ratio}
                circular={circular}
                labelHint={labelHint}
                freeCrop={freeCrop}
                shouldResize={options.shouldResize}
                minWidth={minWidth}
                minHeight={minHeight}
                {...extraProps}
                required={!value && required}
                validations={{
                    ...validation.rules,
                    isCropping: (values, value) => {
                        return value !== 'isCropping';
                    }
                }}
                validationErrors={{...validation.errors, isCropping: 'Please confirm image'}}/>
        );
    }

    static pixieImageField(options) {
        let {
            label,
            labelHint,
            name,
            value,

            width,
            height,
            ratio,
            circular,
            dropContainer,
            disabled,
            required,
            validation,
            freeCrop,
            minWidth,
            minHeight,
            ...extraProps
        } = options;

        // ImageUpload props
        // source = value (nullable string - url of image)
        // width @= int (optional, default=150)
        // height @= int pixels (optional, default=auto)
        // ratio @= float (optional, default=null)
        // circular @= bool (optional, default=false)
        // ImageUpload methods
        // + onError(error => )
        // handle bad mime type
        // handle size too large

        return (
            <PixieImageUpload
                label={label}
                name={name}
                source={value}
                value={value}
                disabled={disabled}
                width={width}
                height={height}
                dropContainer={dropContainer}
                ratio={ratio}
                circular={circular}
                labelHint={labelHint}
                freeCrop={freeCrop}
                shouldResize={options.shouldResize}
                minWidth={minWidth}
                minHeight={minHeight}
                {...extraProps}
                required={!value && required}
                validations={{
                    ...validation.rules,
                    isCropping: (values, value) => {
                        return value !== 'isCropping';
                    }
                }}
                validationErrors={{...validation.errors, isCropping: 'Please confirm image'}}/>
        );
    }

    static multiImageField(options) {
        let {
            label,
            labelHint,
            name,
            value,
            disabled,
            required,
            validation,
            minWidth,
            minHeight,
            ...extraProps
        } = options;

        // ImageUpload props

        return (
            <MultiImageUpload
                label={label}
                name={name}
                value={value}
                disabled={disabled}
                labelHint={labelHint}
                minWidth={minWidth}
                minHeight={minHeight}
                {...extraProps}
                required={!value && required}
                validations={{
                    ...validation.rules,
                    isCropping: (values, value) => {
                        return value !== 'isCropping';
                    }
                }}
                validationErrors={validation.errors}/>
        );
    }
    static multiDocField(options) {
        let {
            label,
            labelHint,
            name,
            value,
            disabled,
            required,
            validation,
            ...extraProps
        } = options;

        // ImageUpload props

        return (
            <MultiDocUpload
                label={label}
                name={name}
                value={value}
                disabled={disabled}
                labelHint={labelHint}
                {...extraProps}
                required={!value && required}
                validations={{
                    ...validation.rules,
                }}
                validationErrors={validation.errors}/>
        );
    }
}

const FormInputComponent = ({fieldName, ...options}) => {
    return Form.getFormComponent(fieldName, {
        name: fieldName,
        label: options.label !== false && TB.startCase(TB.camelCase(fieldName)),
        ...options
    })
}
const generateFormFields = (model,fields) => {
    return TB.map(fields, (params, fieldName) => {
        let options = {...params};

        options.name = options.name ? options.name : fieldName;

        if (options.label && TB.isString(options.label) && options.label.includes('.') && TB.tryTrans(options.label)) {
            options.label = TB.tryTrans(options.label);
        }
        options.label = options.label || options.label === false
            ? options.label : TB.startCase(TB.camelCase(fieldName));

        options.required = options.hasOwnProperty('required') ? options.required : true;

        options.type = options.type ? options.type : 'text';

        if (model && TB.has(model, fieldName)) {
            options.value = TB.get(model, fieldName);
        }

        return Form.getFormComponent(fieldName, options)
    })
}
const validationFor = Form.validationFor;
export {
    validationFor,
    generateFormFields,
    FormInputComponent
}

// todo:
// validate custom fields:
//     validated location field
//     validated image upload field

// configure to perform api posts
//     handle custom error response
//     handle success
//     multipart form-data w/ files
//     show loading/submitting feedback